import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import ButtonIcon from "components/ButtonComp";
import CustomTitle from "components/CustomTitle";
import SelectComp from "components/SelectComp";
import useETDStatuses from "hooks/useETDStatuses";
import { IETDStatus } from "models/ETDStatus";
import React, { useState, useRef } from "react";
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from "recharts";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import useLoading from "hooks/useLoading";

interface ETDChartProps {
    etd_id: number;
}

// data: resultado de la consulta GraphQL
const ETDChart: React.FC<ETDChartProps> = ({ etd_id }) => {
    const [pageSize, setPageSize] = useState<number>(12);
    const hookLoading = useLoading({ defaultLoading: false });
    const chartRef = useRef<HTMLDivElement>(null);

    const hookETDStatus = useETDStatuses({ etd_id, orderBy: "desc", pageSize });

    const handleDownloadPDF = async () => {
        hookLoading.start();
        if (chartRef.current) {
            const canvas = await html2canvas(chartRef.current);
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('landscape', 'mm', 'a4');
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = canvas.width;
            const imgHeight = canvas.height;
            const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
            const imgX = (pdfWidth - imgWidth * ratio) / 2;
            const imgY = 30;

            pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
            pdf.save(`etd_${new Date().getTime()}.pdf`);
        }
        hookLoading.end();
    };

    return (
        <div >
            <CustomTitle
                className="mb-4"
                actions={[
                    <SelectComp
                        key="period"
                        size="sm"
                        name='period'
                        options={[
                            { label: 'Última hora', value: (12 * 1).toString() },
                            { label: 'Últimas 2 horas', value: (12 * 2).toString() },
                            { label: 'Últimas 6 horas', value: (12 * 6).toString() },
                            { label: 'Últimas 12 horas', value: (12 * 12).toString() },
                            { label: 'Últimas 24 horas', value: (12 * 24).toString() },
                            { label: 'Últimos 7 días', value: (12 * 24 * 7).toString() },
                            { label: 'Últimos 30 días', value: (12 * 24 * 30).toString() },
                        ]}
                        onChange={(e) => setPageSize(Number(e.target.value))}
                        value={pageSize.toString()}
                    />,
                    <ButtonIcon key="download" name="Descargar" icon={faFilePdf} variant="danger" onClick={handleDownloadPDF} disabled={hookLoading.isLoading} />
                ]}
            />
            <ResponsiveContainer width="100%" height={400} ref={chartRef}>
                <LineChart
                    data={hookETDStatus.data
                        .map((item: IETDStatus) => ({ ...item, created_at: new Date(item.created_at).toLocaleString() }))
                        .sort((a: IETDStatus, b: IETDStatus) => a.id - b.id)
                    }
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="created_at" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="Intensidad" stroke="#ff7300" name="Intensidad" />
                    <Line type="monotone" dataKey="Error_relativo" stroke="#387908" name="Error relativo" />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default ETDChart;